<template>
  <div>
    <v-dialog v-model="show" :max-width="csvDialogMaxWidth">
      <v-card>
        <v-card-title>
          <span class="text-h5 font-weight-bold">CSVインポート</span>
        </v-card-title>
        <v-card-text class="mt-4 mb-n6">
          <v-file-input
            v-model="csvFile" label="CSVファイルを選択" accept=".csv" dense outlined :key="inputKey" @change="inputCsv"
            :success-messages="csvFile && csvDataErrMsg.length == 0 ? 'ファイルの読み込みが完了しました。' : ''"
            :error-messages="csvDataErrMsg.length != 0 ? 'ファイルの読み込みに失敗しました。エラーが' + csvDataErrMsg.length + '件発生しています。' : ''"
          ></v-file-input>
          <div v-if="csvDataErrMsg.length != 0" max-height="200px" class="mb-6" style="max-height: 300px; overflow-y: auto;">
            <div v-for="(data, index) in csvDataErrMsg" :key="index">
              <v-alert dense text color="error" icon="mdi-alert-outline">{{ data }}</v-alert>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="green" dark @click="show = false" outlined>キャンセル</v-btn>
          <v-btn :disabled="csvDataErrMsg.length != 0 || !csvFile" :loading="loading" color="green white--text"
            @click="sendCsv()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Papa from 'papaparse';
import Vue from "vue";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  UPLOAD_MULTI_STUDENT,
} from "@/store/action-types";
import {
  REQUIRED_ERROR_MSG,
  CSV_FILE_ERROR_MSG,
} from "@/constants";

export default Vue.extend({
  name: "StudentCsvImport",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    studentsAll: Array,
    classroomAll: Array,
  },
  data() {
    return {
      loading: false,
      csvFile: null,
      csvData: [],
      csvDataErrMsg: [],
      studentCsv: null,
      inputKey: 0,
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
    csvDialogMaxWidth() {
      return "600px";
    },
  },
  methods: {
    ...mapActions({
      uploadMultiStudent: UPLOAD_MULTI_STUDENT,
    }),
    async inputCsv() {
      this.inputKey += 1; // 同じファイルを再選択した場合でも@changeを発火させる
      this.csvDataErrMsg = [];
      const file = this.csvFile;
      if (file) {
        const reader = new FileReader();
        reader.readAsText(file, 'Shift-JIS'); // Shift-JIS形式で読み込む
        reader.onload = async () => {
          const csv = reader.result;
          const results = Papa.parse(csv, { header: true });
          const products = results.data;
          this.csvData = this.csvDataKeyChange(products);
          this.convertGradeIdType(); // Excelで保存した際に'01'が数値の1に変換されてしまう事象に対応
          this.convertClassIdType(); // Excelで保存した際に'01'が数値の1に変換されてしまう事象に対応
          this.csvDataValidateCheck();
        };
      }

    },
    convertGradeIdType() {
      // (数値,文字列,0埋め文字列)を0埋め文字列に変換
      for (let i = 0; i < this.csvData.length; i++) {
        const grade = this.csvData[i].grade;
        let gradeId = '';
        if(grade != undefined && grade != '' && grade != null){
          gradeId = String(grade).padStart(2, '0');
        }
        this.csvData[i].grade = gradeId;
      }
    },
    convertClassIdType() {
      // (数値,文字列,0埋め文字列)を0埋め文字列に変換
      for (let i = 0; i < this.csvData.length; i++) {
        const classroom = this.csvData[i].classroom;
        let classId = '';
        if(classroom != undefined && classroom != '' && classroom != null){
          classId = String(classroom).padStart(2, '0');
        }
        this.csvData[i].classroom = classId;
      }
    },
    csvDataValidateCheck() {
      let deleteRowIndexList = [];
      let importCount = 0;
      for (let i = 0; i < this.csvData.length; i++) {
        const data = this.csvData[i]
        if (this.deleteNullOrEmptyRow(data)) {
          deleteRowIndexList.push(i)
        } else {
          this.checkLastNameValidate(data, i + 2)
          this.checkLastNameKanaValidate(data, i + 2)
          this.checkFirstNameValidate(data, i + 2)
          this.checkFirstNameKanaValidate(data, i + 2)
          this.checkGradeValidate(data, i + 2)
          this.checkClassValidate(data, i + 2)
          this.checkNumberValidate(data, i + 2)
          this.hasClassInClassroomAll(data, i + 2)
          this.sameClassroomNumberInfile(data, i + 2)
          importCount++;
        }
      }
      for (let i = 0; i < deleteRowIndexList.length; i++) {
        this.csvData.splice(deleteRowIndexList[i] - i, 1)
      }
      if (importCount == 0) {
        this.csvDataErrMsg.push(CSV_FILE_ERROR_MSG);
      }
    },
    sameClassroomNumberInfile(data, n) {
      const posErrMsg = "行目でエラー : ";
      const sameClassroomNumberInFile = "ファイル内にクラスと出席番号が同一の生徒が居ます。"

      const grade = data.grade
      const classroom = data.classroom
      const number = data.number
      for (let i = (n - 1); i < this.csvData.length; i++) {
        if (this.csvData[i].grade === grade && this.csvData[i].classroom === classroom && this.csvData[i].number === number) {
          this.csvDataErrMsg.push(n + posErrMsg + sameClassroomNumberInFile)
          return
        }
      }
    },
    hasClassInClassroomAll(data, n) {
      const posErrMsg = "行目でエラー : ";
      const notHasClassErrMsg = "存在しないか、権限がないクラスです。"
      const sameClassroomNumber = "既にクラスと出席番号が同一の生徒が居ます。"

      const grade = data.grade
      const classroom = data.classroom

      for (let i = 0; i < this.classroomAll.length; i++) {
        const obj = this.classroomAll[i];
        if (obj.grade_position === grade && obj.class_position === classroom) {
          const classroom_id = obj.classroom_id
          let errFlag = 0
          for (let i = 0; i < this.studentsAll.length; i++) {
            if (Number(this.studentsAll[i].is_delete) === Number(0)) {
              if (this.studentsAll[i].number == data.number && this.studentsAll[i].classroom_id == classroom_id) {
                errFlag = 1
              }
            }
          }
          if (errFlag != 0) {
            this.csvDataErrMsg.push(n + posErrMsg + sameClassroomNumber)
          }
          return
        }
      }
      this.csvDataErrMsg.push(n + posErrMsg + notHasClassErrMsg)
    },
    checkNumberValidate(data, i) {
      // 姓（かな・）のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "出席番号" + REQUIRED_ERROR_MSG
      const lengthErrMsg = "出席番号は半角数字2文字以内で入力してください。"
      const halfNumLengthErrMsg = "出席番号は半角数字2文字以内で入力してください。"

      const validateTarget = data.number;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      } else if (validateTarget !== null && validateTarget.length > 2) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)

      } else if (!(/^\d{1,2}$/.test(validateTarget))) {
        this.csvDataErrMsg.push(i + posErrMsg + halfNumLengthErrMsg)
      }
    },
    checkClassValidate(data, i) {
      // 姓（かな・カナ）のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "クラス" + REQUIRED_ERROR_MSG
      // const lengthErrMsg = "クラスは全角10文字以内で入力してください。"
      // const notHasClassErrMsg = "存在しないか、権限がないクラスです。"
      const halfNumLengthErrMsg = "クラスは半角数字2文字以内で入力してください"

      const validateTarget = data.classroom;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      // } else if (validateTarget !== null && validateTarget.length > 2) {
      //   this.csvDataErrMsg.push(i + posErrMsg + halfNumLengthErrMsg)

        // } else if (!this.hasClassInClassroomAll(data)) {
        //   this.csvDataErrMsg.push(i + posErrMsg + notHasClassErrMsg)
      } else if (!(/^\d{1,2}$/.test(validateTarget))) {
        this.csvDataErrMsg.push(i + posErrMsg + halfNumLengthErrMsg)
      }
    },
    checkGradeValidate(data, i) {
      // 姓（かな・カナ）のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "学年" + REQUIRED_ERROR_MSG
      // const lengthErrMsg = "学年は10文字以内で入力してください。"
      // const halfNumLengthErrMsg = "学年は半角数字1文字以内で入力してください"

      const validateTarget = data.grade;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      // } else if (validateTarget !== null && validateTarget.length > 1) {
      //   this.csvDataErrMsg.push(i + posErrMsg + halfNumLengthErrMsg)

      // } else if (!(/^\d{1}$/.test(validateTarget))) {
      //   this.csvDataErrMsg.push(i + posErrMsg + halfNumLengthErrMsg)
      }
    },
    checkFirstNameKanaValidate(data, i) {
      // 姓（かな・カナ）のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "名（かな・カナ）" + REQUIRED_ERROR_MSG
      const lengthErrMsg = "名（かな・カナ）は全角ひらがな・カタカナ20文字以内で入力してください。"
      //const fullWidthErrMsg = "名（かな・カナ）は全角ひらがな・カタカナ20文字以内で入力してください。"

      const validateTarget = data.first_name_kana;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      } else if (validateTarget !== null && validateTarget.length > 20) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)

      } else if (!/^[ぁ-んァ-ヶー]+$/.test(validateTarget)) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)
      }
    },
    checkFirstNameValidate(data, i) {
      // 姓のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "名" + REQUIRED_ERROR_MSG
      const lengthErrMsg = "名は全角10文字以内で入力してください。"
      //const fullWidthErrMsg = "名は全角で入力してください。"

      const validateTarget = data.first_name;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      } else if (validateTarget !== null && validateTarget.length > 10) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)

      } else if (!/* eslint no-control-regex: off */ /[^\x01-\x7E\uFF61-\uFF9F]+$/.test(validateTarget)) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)
      }
    },
    checkLastNameKanaValidate(data, i) {
      // 姓（かな・カナ）のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "姓（かな・カナ）" + REQUIRED_ERROR_MSG
      const lengthErrMsg = "姓（かな・カナ）は全角ひらがな・カタカナ20文字以内で入力してください。"
      const fullWidthErrMsg = "姓（かな・カナ）は全角ひらがな・カタカナ20文字以内で入力してください。"

      const validateTarget = data.last_name_kana;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      } else if (validateTarget !== null && validateTarget.length > 20) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)

      } else if (!/^[ぁ-んァ-ヶー]+$/.test(validateTarget)) {
        this.csvDataErrMsg.push(i + posErrMsg + fullWidthErrMsg)
      }
    },
    checkLastNameValidate(data, i) {
      // 姓のvalidation
      const posErrMsg = "行目でエラー : ";
      const emptyErrMsg = "姓" + REQUIRED_ERROR_MSG
      const lengthErrMsg = "姓は全角10文字以内で入力してください。"
      const fullWidthErrMsg = "姓は全角10文字以内で入力してください。"

      const validateTarget = data.last_name;

      if (validateTarget == null || validateTarget == "") {
        this.csvDataErrMsg.push(i + posErrMsg + emptyErrMsg)

      } else if (validateTarget !== null && validateTarget.length > 10) {
        this.csvDataErrMsg.push(i + posErrMsg + lengthErrMsg)

      } else if (!/* eslint no-control-regex: off */ /[^\x01-\x7E\uFF61-\uFF9F]+$/.test(validateTarget)) {
        this.csvDataErrMsg.push(i + posErrMsg + fullWidthErrMsg)
      }
    },
    deleteNullOrEmptyRow(csvData) {
      if (
        (csvData.last_name == "" || !csvData.last_name) &&
        (csvData.last_name_kana == "" || !csvData.last_name_kana) &&
        (csvData.first_name == "" || !csvData.first_name) &&
        (csvData.first_name_kana == "" || !csvData.first_name_kana) &&
        (csvData.grade == "" || !csvData.grade) &&
        (csvData.classroom == "" || !csvData.classroom) &&
        (csvData.number == "" || !csvData.number)
      ) {
        return true
      }
      return false
    },
    csvDataKeyChange(csvData) {
      // csvDataのキー名を日本語から英語に変える
      for (let i = 0; i < csvData.length; i++) {
        csvData[i].last_name = csvData[i]['姓']
        delete csvData[i]['姓'];

        csvData[i].last_name_kana = csvData[i]['姓（かな・カナ）']
        delete csvData[i]['姓（かな・カナ）']

        csvData[i].first_name = csvData[i]['名']
        delete csvData[i]['名']

        csvData[i].first_name_kana = csvData[i]['名（かな・カナ）']
        delete csvData[i]['名（かな・カナ）']

        csvData[i].grade = csvData[i]['学年']
        delete csvData[i]['学年']

        csvData[i].classroom = csvData[i]['クラス']
        delete csvData[i]['クラス']

        csvData[i].number = csvData[i]['出席番号']
        delete csvData[i]['出席番号'];
      }
      return csvData
    },
    async sendCsv() {
      this.loading = true
      let index = 0;
      const chunkSize = 50;
      this.loadingDialogText = '生徒情報を登録中です。'
      this.allDownloadingLength = '%'
      while (index < this.csvData.length) {
        this.currentDownloadingClass = Math.floor(((index == 0 ? 1 : index) / this.csvData.length) * 100);
        let chunk = this.csvData.slice(index, index + chunkSize);
        await this.uploadMultiStudent(chunk);
        index += chunkSize;
      }
      this.loadingDialogText = ''
      this.allDownloadingLength = ''
      this.currentDownloadingClass = ''
      this.show = false;
      this.$emit('studentCsvImport');
    },
  }
});
</script>